import { groq } from 'next-sanity';

export const postquery = groq`
*[_type == "post"] | order(publishedAt desc, _createdAt desc)[$start...$end] {
  ...,
  author->,
  categories[]->,
  "estReadingTime": round(length(pt::text(body)) / 5 / 180 )
}
`;

export const getSERPPostsQuery = groq`
*[_type == "post"] | order(publishedAt desc, _createdAt desc)[$start...$end] {
  _id,
  title,
  publishedAt,
  slug,
  mainImage,
  "author": author->{
    name,
    slug,
  },
  excerpt,
  "estReadingTime": round(length(pt::text(body)) / 5 / 180 ),
  "totalCommentsCount": count(comments[]),
  categories[]->,
}
`;

export const getFeaturedPostsQuery = groq`
*[_type == "post"] | order(coalesce(featured, false) desc, publishedAt desc, _createdAt desc)[$start...$end] {
  _id,
  title,
  publishedAt,
  featured,  
  slug,
  mainImage,
  "author": author->{
    name,
    slug,
    image
  },
  excerpt,
  "estReadingTime": round(length(pt::text(body)) / 5 / 180 ),
  "totalCommentsCount": count(comments[]),
  categories[]->,
  isFoodBlog,
  recipeDetails,
}
`;

export const getSearchQuery = groq`
    *[_type == "post" && (
      title match "*$search*" || 
      excerpt match "*$search*" || 
      pt::text(body) match "*$search*" ||
      categories[]->title match "*$search*"
    )] | order(featured desc, publishedAt desc) {
      _id,
      title,
      slug,
      excerpt,
      mainImage,
      "author": author->{
        name,
        slug,
        image
      },
      "estReadingTime": round(length(pt::text(body)) / 5 / 180 ),
      "totalCommentsCount": count(comments[]),
      categories[]->,
      publishedAt,
      featured
    }
  `;

export const postCountQuery = `count(*[_type == "post"])`;

export const configQuery = groq`
*[_type == "siteconfig"][0] {
  ...,
}
`;

export const getCategory = groq`
*[_type == "category" && slug.current == $slug]{
  ...,
  "posts": *[_type == "post" && references(^._id)] | order(publishedAt desc, _createdAt desc){
  _id,
  title,
  publishedAt,  
  slug,
  mainImage,
  "author": author->{
    name,
    slug,
    image
  },
  excerpt,
  "estReadingTime": round(length(pt::text(body)) / 5 / 180 )
  }
}[0]
`;

export const getAllCategories = groq`
*[_type == "category"] {
  ...,
  "totalPost": *[_type == "post" && references(^._id)]
}
`;

export const getAllCategoriesSerp = groq`
*[_type == "category"] {
 color,
  title,
  slug,
  _id,
  "totalPost": *[_type == "post" && references(^._id)][0...4]{
    _id,
    title,
    slug
  },
  "totalPostCount": count(*[_type == "post" && references(^._id)])
}
`;

export const getAllAuthors = groq`
*[_type == "author"] {
  ...,
}
`;

export const getAuthor = groq`
*[_type == "author" && slug.current == $slug]{
  ...,
  "posts": *[_type == "post" && references(^._id)] | order(publishedAt desc, _createdAt desc) {
   _id,
  title,
  publishedAt,  
  slug,
  mainImage,
  "author": author->{
    name,
    slug
  },
  excerpt,
  "estReadingTime": round(length(pt::text(body)) / 5 / 180 )
  }
}[0]
`;

export const singlequery = groq`
*[_type == "post" && slug.current == $slug][0] {
  ...,
  author->,
  categories[]->,
  comments[]->,
  "estReadingTime": round(length(pt::text(body)) / 5 / 180 )
}
`;

export const pathquery = groq`
*[_type == "post"] {
  'slug': slug.current,
}
`;

export const authorsquery = groq`
*[_type == "author"] {
  ...,
}
`;

// test below
// to delete later

export const listquery = groq`
*[_type == "listing"] | order(_createdAt desc) [$start..$end] {
  ...,
  category->
 }
`;

export const productquery = groq`
*[_type == "listing" && slug.current == $slug][0] {
  ...,
  category-> {
    ...,
    enqform->,
    vendorform->
  }
 }
`;

// Fixed version of the enhanced author query without using unique() function
export const getEnhancedAuthor = groq`
*[_type == "author" && slug.current == $slug][0]{
  ...,
  "posts": *[_type == "post" && references(^._id)] | order(publishedAt desc, _createdAt desc)[0...12] {
    _id,
    title,
    publishedAt,
    _createdAt,
    featured,
    slug,
    mainImage,
    "author": author->{
      name,
      slug,
      image
    },
    excerpt,
    "estReadingTime": round(length(pt::text(body)) / 5 / 180),
    "totalCommentsCount": count(comments[]),
    categories[]->
  },
  "totalPosts": count(*[_type == "post" && references(^._id)]),
  "featuredPosts": count(*[_type == "post" && references(^._id) && featured == true]),
  "commentCounts": *[_type == "post" && references(^._id)][]{
    "count": count(comments[])
  },
  "topCategories": *[_type == "category" && count(*[_type == "post" && references(^._id) && author._ref == $authorId]) > 0] {
    _id,
    title,
    slug,
    "count": count(*[_type == "post" && references(^._id) && author._ref == $authorId])
  } | order(count desc)[0...5],
  "firstPublished": *[_type == "post" && references(^._id)] | order(publishedAt asc)[0].publishedAt,
  "latestPublished": *[_type == "post" && references(^._id)] | order(publishedAt desc)[0].publishedAt,
  "relatedAuthors": *[_type == "author" && _id != ^._id]{
    _id,
    name,
    slug,
    image,
    bio,
    "postCount": count(*[_type == "post" && references(^._id)])
  }
}
`;

// Enhanced getAllAuthors query with more detailed stats
export const getAllAuthorsWithStats = groq`
*[_type == "author"] {
  _id,
  name,
  slug,
  image,
  bio,
  location,
  role,
  email,
  twitter,
  instagram,
  linkedin,
  "posts": *[_type == "post" && references(^._id)] | order(publishedAt desc, _createdAt desc)[0...5] {
    _id,
    title,
    publishedAt,  
    _createdAt,
    slug,
    mainImage,
    excerpt,
    featured,
    categories[]->,
    "totalCommentsCount": count(comments[]),
  },
  "postCount": count(*[_type == "post" && references(^._id)]),
  "featuredPostCount": count(*[_type == "post" && references(^._id) && featured == true]),
  "firstPost": *[_type == "post" && references(^._id)] | order(publishedAt asc)[0] {
    _id,
    title,
    publishedAt,
    _createdAt
  },
  "latestPost": *[_type == "post" && references(^._id)] | order(publishedAt desc)[0] {
    _id,
    title,
    slug,
    publishedAt,
    _createdAt
  }
}
`;
